import { LeadPriorityScore, type TriggeredRule } from "app/pages/sales-intelligence/domain/leads/types/lead-priority";

const TRIGGERED_RULE_SCORE_PRIORITY: Readonly<Record<TriggeredRule["score"], number>> = {
    [LeadPriorityScore.High]: 3,
    [LeadPriorityScore.Medium]: 2,
    [LeadPriorityScore.Low]: 1,
};

export const getSortedTriggeredRules = (triggeredRules: readonly TriggeredRule[]): readonly TriggeredRule[] => {
    return [...triggeredRules].sort(
        (a, b) => TRIGGERED_RULE_SCORE_PRIORITY[b.score] - TRIGGERED_RULE_SCORE_PRIORITY[a.score],
    );
};
